 <app-table-title [title]="'PROXY' | dictionary"></app-table-title>

 <div class="row">
   <div class="col-lg-12">
     <div class="m-portlet m-portlet--unair" style="margin-bottom: 0px;">
       <div class="pr-2 home-middle-header-bgcolor" style="display: flex;">
         <div class="form-row col-lg-12 pt-2 pb-2">
           <div class="input-wrapper" [formGroup]="form">
             <label class="margin-0 text-color-1">{{'CONTROL_NUMBER_LABEL_TEXT' | dictionary}}</label>

             <div class="input-inner-wrapper">
               <input type="text" [formControl]="form.get('controlNumber')"/>
               <button (click)="validate()" type="submit" class="button">{{'VALIDATE' | dictionary}}</button>
             </div>
             <span class="error-note"
                   [ngClass]="{'opacity-0' : !form.get('controlNumber').invalid || !form.get('controlNumber').touched}"
             >{{'CONTROL_NUMBER_VALIDATION_ERROR' | dictionary}}</span>
           </div>

         </div>
       </div>
     </div>
   </div>
 </div>


 <div class="table-container" *ngIf="issues">

   <div class="m-portlet m-portlet--unair top-row m-portlet__head text-color-1">
     {{'PROXY_DESCRIPTION' | dictionary}}
   </div>

   <div class="content-wrapper">
     <div class="actions-header">
       <div class="left-column">
         <div class="left-column-content">
           <button (click)="voteAsRecommends()" class="button-1">{{'VOTE_AS_RECOMMENDS' | dictionary}}</button>
           <span class="left-note" [innerHTML]="'VOTE_NOTE' | dictionary"></span>
         </div>
       </div>

       <div class="right-column align-items-stretch">

         <span class="font-weight-bold text-center vote-hint">{{'VOTE_ALL_HINT' | dictionary}}</span>
         <div class="vote-wrapper">
           <div *ngFor="let option of voteOptions; let radioIndex = index" class="vote-option">
             <input type="radio" name="allRowsRadioButton"
                    [id]="'allRowsRadioButton' + radioIndex"
                    [value]="option.value"
                    [(ngModel)]="allRowsVoteValue"
                    [ngClass]="{
                        'green' : radioIndex === 0,
                        'red' : radioIndex === 1,
                        'orange' : radioIndex === 2
                      }"
                    (change)="setAllVote(option.value)"/>
             <label [for]="'allRowsRadioButton' + radioIndex">{{option.value}}</label>
           </div>
         </div>
         <br>
         <span class="font-weight-bold text-center vote-hint">{{'VOTE_HINT' | dictionary}}</span>

       </div>
     </div>

     <div class="issues-wrapper">
       <ng-container *ngFor="let issue of issues; let i = index">
         <div class="issue-row" *ngIf="!issue.IsDirectorsIssue">
           <div class="issue-description left-column">
             <div class="index">{{ issue.IssueNumber }}</div>
             {{issue.IssueDescription}}
           </div>
           <div class="vote-wrapper right-column">
             <div *ngFor="let option of voteOptions; let radioIndex = index" class="vote-option">
               <input type="radio"
                      [name]="'issue_' + issue.IssueNumber.toString()"
                      [value]="option.value"
                      [(ngModel)]="selectedVoteValues[i]"
                      [ngClass]="{
                        'green' : radioIndex === 0,
                        'red' : radioIndex === 1,
                        'orange' : radioIndex === 2
                      }"
                      (change)="setVote(i, option.value)"/>
             </div>
           </div>
         </div>

         <div *ngIf="issue.IsDirectorsIssue" class="issue-row directors-wrapper">
           <div class="issue-description left-column">
             <div class="index">{{ issue.IssueNumber }}</div>
             {{issue.IssueDescription}}
           </div>

           <div class="director-row" *ngFor="let director of directors; let i = index">
             <div class="left-column"><div class="director-name">{{director.Director}}</div></div>
             <div class="vote-wrapper right-column">
               <div *ngFor="let option of voteOptions; let radioIndex = index" class="vote-option">
                 <input type="radio"
                        [name]="'director_' + director.DirectorNumber.toString()"
                        [(ngModel)]="selectedDirectorsVoteValues[i]"
                        [value]="option.value"
                        [ngClass]="{
                      'hidden-option' : radioIndex === 2,
                      'green' : radioIndex === 0,
                      'orange' : radioIndex === 2,
                      'red' : radioIndex === 1
                    }"
                        (change)="selectedDirectorsVoteValues[i] = option.value"/>
               </div>
             </div>
           </div>
         </div>
       </ng-container>
     </div>

<!--     <div class="directors-wrapper" *ngIf="showDirectors">-->
<!--       <div class="directors-wrapper__title">-->
<!--         {{directorsIssue.IssueDescription}}-->
<!--       </div>-->
<!--       <div class="director-row" *ngFor="let director of directors; let i = index">-->
<!--         <div class="director-name left-column">{{director.Director}}</div>-->
<!--         <div class="vote-wrapper right-column">-->
<!--           <div *ngFor="let option of voteOptions; let radioIndex = index" class="vote-option">-->
<!--             <input type="radio"-->
<!--                    [name]="'director_' + director.DirectorNumber.toString()"-->
<!--                    [(ngModel)]="selectedDirectorsVoteValues[i]"-->
<!--                    [value]="option.value"-->
<!--                    [ngClass]="{-->
<!--                      'hidden-option' : radioIndex === 2,-->
<!--                      'green' : radioIndex === 0,-->
<!--                      'orange' : radioIndex === 2,-->
<!--                      'red' : radioIndex === 1-->
<!--                    }"-->
<!--                    (change)="selectedDirectorsVoteValues[i] = option.value"/>-->
<!--           </div>-->
<!--         </div>-->
<!--       </div>-->
<!--     </div>-->

     <div class="bottom-actions"
          [style.left.%]="isMenuShown ? 25 : 0"
     >
       <button (click)="registerVote()" class="button-1">{{'REGISTER_VOTE' | dictionary}}</button>

     </div>

   </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()"></app-pop-up-dialog>
